export default function GoodbyePage() {
  const G = "#0077B5";
  return (
    <div style={{ background: "#F3F2EF", minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "-apple-system,'Segoe UI',Helvetica,sans-serif" }}>
      <div style={{ maxWidth: 480, width: "100%", padding: "48px 24px", textAlign: "center" }}>
        <div style={{ fontFamily: "'Playfair Display',Georgia,serif", fontSize: 24, fontWeight: 700, color: G, marginBottom: 48 }}>BrandHives</div>
        <div style={{ fontFamily: "'Playfair Display',Georgia,serif", fontSize: 28, fontWeight: 700, color: "#1A1A1A", marginBottom: 16, lineHeight: 1.3 }}>
          Your account has been cancelled.
        </div>
        <p style={{ fontSize: 15, color: "#666", lineHeight: 1.8, marginBottom: 40 }}>
          Your posting history has been saved. If you ever want to come back, your hive will be here.
        </p>
        <button
          onClick={() => { window.location.hash = "#/start"; }}
          style={{ background: G, color: "#fff", border: "none", borderRadius: 10, padding: "16px 32px", fontSize: 15, cursor: "pointer", fontFamily: "'Playfair Display',Georgia,serif" }}
        >
          Start a new account
        </button>
        <div style={{ marginTop: 48, fontSize: 12, color: "#ccc" }}>
          AI by Claude · Payments secured by Stripe · Developed by BHIVE™ Labs
        </div>
      </div>
    </div>
  );
}
